import { Component } from "@angular/core";

@Component({
	selector: 'app-club-interviews-summary-report',
	templateUrl: './club-interviews-summary-report.component.html'
})
export class ClubInterviewsSummaryReportComponent {

}